import React from 'react';
import { SubmitButton } from 'ui-builder';
import useAuthorizationChecker from '../../../../shared/authorization/authorizationChecker';
import CreateDependentTaskButton from './CreateDependentTaskButton';
import { TaskPermission } from 'nekst-api';
import DeleteTaskButton from './DeleteTaskButton';
import { PreviewAndUpdateEventButton } from "features/tasks-forms";

const buttonsContainerStyle: React.CSSProperties = {
  display: 'flex',
  justifyContent: 'space-between',
  alignItems: 'center',
  width: '100%',
};

const leftGroupStyle: React.CSSProperties = {
  display: 'flex',
  gap: '1rem',
  alignItems: 'center',
};

export function UpdateEventTaskButtons() {
  const { isGranted } = useAuthorizationChecker();

  if (isGranted(TaskPermission.UPDATE)) {
    return (
      <div style={buttonsContainerStyle}>
        <div style={leftGroupStyle}>
          <PreviewAndUpdateEventButton />
          <CreateDependentTaskButton />
        </div>
        <DeleteTaskButton />
      </div>
    );
  } else {
    return null;
  }
}

export default function UpdateTaskButtons() {
  const { isGranted } = useAuthorizationChecker();

  if (isGranted(TaskPermission.UPDATE)) {
    return (
      <div style={buttonsContainerStyle}>
        <div style={leftGroupStyle}>
          <SubmitButton text="Update task" key="save" />
          <CreateDependentTaskButton />
        </div>
        <DeleteTaskButton />
      </div>
    );
  } else {
    return null;
  }
}
